export default __webpack_public_path__ + "static/media/anythingdb_openapi.40dee757.yaml";